// export const SERVER_URL = 'http://localhost:3000';
export const SERVER_URL = 'https://hacademy-api.herokuapp.com';
export const PUBLISH_KEY_STRIPE = 'pk_test_bVMx06pYmPZ1mR7lj74RSrlf00TcSnax3B';
export const AUTH_TOKEN = 'AUTH_TOKEN';
export const SEARCH = 'SEARCH';
export const APP_ID = '291773038524316';
export const PAGE_ID = '103199398091895';

export const FIREBASE_MESSAGE_REF = 'messages';
export const FIREBASE_STATUS_REF = 'status';
export const FIREBASE_CONNECTED_REF = '.info/connected';

export const IMAGE_URL = {
  BACKGROUND_1: 'https://cdn.pixabay.com/photo/2017/06/23/11/49/laptop-2434393_1280.jpg',
  BACKGROUND_2: 'https://cdn.pixabay.com/photo/2016/03/27/22/04/camera-1284459_1280.jpg',
  BACKGROUND_3: 'https://cdn.pixabay.com/photo/2015/05/31/15/07/business-792113_1280.jpg',
  NO_AVATAR: `${SERVER_URL}/images/no-avatar.png`,
};

export const TAB = {
  PERSONAL_INFORMATION: 'personal-information',
  CHANGE_PASSWORD: 'change-password',
  INVOICES: 'invoices',
};

export const AUTH = {
  LOGIN: 'login',
  REGISTER: 'register',
  FORGOTPASSWORD: 'forgotpassword',
  CHANGEPASSWORD: 'changepassword',
};

export const PATH = {
  LOGIN: '/login',
  REGISTER: '/register',
  FORGOT_PASSWORD: '/forgot-password',
  AUTH: '/auth',
  AUTH_LOGIN: '/auth/login',
  AUTH_REGISTER: '/auth/register',
  AUTH_FORGOT_PASSWORD: '/auth/forgot-password',
  AUTH_RESET_PASSWORD: '/auth/reset-password',
  PROFILE: '/profile',
  PROFILE_USER: '/profileuser',
  LECTURERS: '/lecturers',
  LECTURER_COURSE: '/lecturercourses',
  COURSES: '/courses',
  COURSE_DETAIL: '/course-detail',
  LESSON_DETAIL: '/lesson-detail',
  COURSE_EDIT: '/course-edit',
  CHAT: '/chat',
  CONTACT: '/contact',
  ABOUT: '/about',
  CART: '/cart',
  LOGOUT: '/logout',
};
